<template>
  <portlet
      :icon="'fad fa-file-contract'"
      :title="'Vacature toevoegen'"
      :actionsBlock="true"
      :footer="true"
  >
    <template slot="actionsBlock">
      <router-link tag="button" :to="{name:'vacancies'}" class="btn btn-secondary">
        <i class="fas fa-long-arrow-left mr-2"></i>
        Terug
      </router-link>
    </template>

    <template slot="portletBody">
      <div class="row">
        <div class="form-group col-xl-4">
          <label for="vacancy-name">Naam</label>
          <input name="Naam"
                 id="vacancy-name"
                 type="text"
                 class="form-control"
                 v-validate="'required'"
                 v-model="vacancy.name"
          >
          <span v-if="errors.first('Naam')" class="small text-danger">Dit veld is verplicht</span>
        </div>
        <div class="form-group col-xl-4">
          <label for="vacancy-customer">Bedrijf</label>
          <v-select
              :options="getCustomers"
              :selectOnTab="true"
              label="name"
              @input="setDepartmentAndLocation"
              v-model="vacancy.customer"
              :class="{ 'is-invalid': errors.has('customer')}"
          >
            <div slot="no-options">Geen bedrijven gevonden</div>
          </v-select>
          <input
              v-model="vacancy.customer"
              v-show="false"
              v-validate="'required'"
              name="customer"
          />
          <span v-if="errors.first('customer')" class="small text-danger">Dit veld is verplicht</span>
        </div>

        <div class="form-group col-xl-4" v-if="vacancy.customer">

          <label for="vacancy-customer">Locatie</label>
          <input
              v-model="vacancy.customer.location"
              :disabled="true"
              class="form-control"
              name="customerLocation"
          />
        </div>

        <div class="form-group col-xl-4" v-if="vacancy.customer">
          <label for="vacancy-customer">Vestiging</label>
          <div class="form-group inline-checkboxes">
            <div
                class="custom-control custom-checkbox"
                v-for="department in getDepartments"
                :key="department.value"
            >
              <input
                  v-validate="'required'"
                  v-model="vacancy.departments"
                  :value="department.value"
                  :disabled="department.forced"
                  name="departments"
                  type="checkbox"
                  :id="department.value"
                  class="custom-control-input"
              />
              <label class="custom-control-label" :for="department.value">{{ department.value }}</label>
            </div>
            <span v-if="errors.first('departments')" class="small text-danger">Dit veld is verplicht</span>
          </div>

        </div>

        <div class="form-group col-xl-4 salary-input">
          <label for="vacancy-salaryFrom">Bruto salarisindicatie in euro's per/uur</label>
          <div class="row no-gutters">
            <div class="col-6">
              <input v-validate="'required'"
                     name="vacancy-salaryFrom"
                     id="vacancy-salaryFrom"
                     type="number"
                     class="form-control width-half"
                     v-model="vacancy.salaryFrom"
                     placeholder="Minimaal"
              >
              <span v-if="errors.first('vacancy-salaryFrom')" class="small text-danger">Dit veld is verplicht.</span>
            </div>
            <div class="col-6">
              <input v-validate="'required'"
                     name="vacancy-salaryTo"
                     id="vacancy-salaryTo"
                     type="number"
                     class="form-control width-half"
                     v-model="vacancy.salaryTo"
                     placeholder="Maximaal"
              >
              <span v-if="errors.first('vacancy-salaryTo')" class="small text-danger">Dit veld is verplicht.</span>
            </div>
          </div>
        </div>
        <div class="form-group col-xl-4 hour-input">
          <label for="vacancy-salaryFrom">Werkuren</label>
          <div class="row no-gutters">
            <div class="col-6">
              <v-select
                  :options="workingHours"
                  :selectOnTab="true"
                  label="name"
                  @input="setDepartmentAndLocation"
                  v-model="vacancy.workHours"
                  :class="{ 'is-invalid': errors.has('customer')}"
              />
              <span v-if="errors.first('vacancy-salaryFrom')" class="small text-danger">Dit veld is verplicht.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-lg-6">
          <label>Wat ga je doen als?</label>
          <tiptap-editor
              v-model="vacancy.description"
              :content="vacancy.description"/>
        </div>
        <div class="form-group col-lg-6">
          <label>Introductie</label>
          <tiptap-editor
              v-model="vacancy.introduction"
              :content="vacancy.introduction"/>
        </div>
        <div class="form-group col-lg-6">
          <label>Wie ben jij?</label>
          <tiptap-editor
              v-model="vacancy.descExpect"
              :content="vacancy.descExpect"/>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-6">
          <label>Wat bieden wij jou?</label>
          <tiptap-editor
              v-model="vacancy.descOffer"
              :content="vacancy.descOffer"/>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label>Sector</label>
          <div class="form-group inline-radios">
            <div :key="sector" class="custom-control custom-radio" v-for="sector in sectors">
              <input :value="sector"
                     type="radio"
                     :id="sector"
                     name="known"
                     class="custom-control-input"
                     v-validate="'required'"
                     v-model="vacancy.sector"
              >
              <label class="custom-control-label" :for="sector">{{ sector }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="vacancy.sector === 'Anders'">
        <div class="col-12">
          <v-select
              taggable
              v-model="vacancy.sectorOther"
              :options="knownFromOthers"
              :createOption="createOptionsKnownFrom"
              class="form-group"
              :selectOnTab="true"
          ></v-select>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label>Ploegen</label>
          <div class="form-group inline-checkboxes">
            <div
                class="custom-control custom-checkbox"
                v-for="shift in shiftOptions"
                :key="shift.index"
            >
              <input
                  v-validate="'required'"
                  v-model="vacancy.shifts"
                  :value="shift"
                  name="shift"
                  type="checkbox"
                  :id="shift"
                  class="custom-control-input"
              />
              <label class="custom-control-label" :for="shift">{{ shift }}</label>
            </div>
            <span v-if="errors.first('shift')" class="small text-danger">Dit veld is verplicht</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label>Ervaringen</label>
          <div class="form-group inline-checkboxes">
            <div class="custom-control custom-checkbox"
                 v-for="(experience,index) in getExperiences"
                 :key="'experience-'+index">
              <input v-model="vacancy.experiences"
                     :value="experience.name"
                     type="checkbox"
                     :id="experience.id"
                     class="custom-control-input"
                     name="experiences-name"
                     v-validate="'required'"
              >
              <label class="custom-control-label"
                     :for="experience.id">{{ experience.name }}</label>
            </div>
            <div class="custom-control custom-checkbox">
              <input v-model="vacancy.experiences"
                     value="Anders"
                     type="checkbox"
                     id="experience-other"
                     class="custom-control-input">
              <label class="custom-control-label" for="experience-other">Anders</label>
            </div>
            <span v-if="errors.first('experiences-name')" class="small text-danger">Dit veld is verplicht</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label>Rijbewijs</label>
          <div class="form-group inline-checkboxes">
            <div
                class="custom-control custom-checkbox"
                v-for="driverLicense in driverLicenseOptions"
                :key="driverLicense.index"
            >
              <input
                  v-model="vacancy.driverLicense"
                  :value="driverLicense"
                  type="checkbox"
                  :id="driverLicense"
                  class="custom-control-input"
              />
              <label class="custom-control-label"
                     :for="driverLicense">{{ driverLicense }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-5 upload-image-file">
        <div class="col-md-6 col-xl-3">

          <picture-input
              ref="pictureInput"
              :crop="false"
              width="600"
              height="600"
              margin="16"
              accept="image/*"
              size="10"
              removeButtonClass="btn btn-dark btn-block"
              :hideChangeButton="true"
              :removable="true"
              :custom-strings="{
              upload: '📷 Upload foto',
              drag: '📷 Upload foto',
              tap: '📷 Upload foto',
              change: 'Pas foto aan',
              remove: '🗑️ Verwijder foto'
            }"
              @change="handleFileChange">
          </picture-input>
        </div>
      </div>
      <div class="row">
        <div class="form-group col">
          <label for="vacancy-otherNotes">Overige opmerkingen (intern)</label>
          <textarea
              rows="4"
              id="vacancy-otherNotes"
              name="vacancy-otherNotes"
              class="form-control"
              v-model="vacancy.otherNotes"
          ></textarea>
        </div>
      </div>


      <div class="form-group inline-checkboxes">
        <div class="custom-control custom-checkbox">
          <input
              v-model.number="vacancy.apiActive"
              value="1"
              name="shift"
              type="checkbox"
              id="vacancyApiActive"
              class="custom-control-input"/>
          <label class="custom-control-label" for="vacancyApiActive">Actief op website</label>
        </div>
      </div>
    </template>
    <div slot="portletFooter" class="col-12 text-right">
      <button @click="addVacancy" type="submit" class="btn btn-primary">
        <i class="fal fa-save mr-2"></i> Opslaan
      </button>
    </div>
  </portlet>
</template>

<script>
import {mapGetters} from 'vuex';
import {swalModals} from './../../components/mixins/swalModals.js';
import {imageOrientation} from './../../components/mixins/imageOrientation.js';


export default {
  mixins: [swalModals, imageOrientation],
  data() {
    return {
      disableNavigation: false,
      vacancyCopy: null,
      selectedFile: null,
      sectors: ['Productie', 'Logistiek', 'Anders'],
      workingHours: [4, 8, 12, 16, 20, 24, 28, 32, 36, 40, "Fulltime"],
      driverLicenseOptions: ['Brommer AM', 'Auto B', 'Vrachtwagen C', 'Vrachtwagen CE', 'Trekker T'],
      shiftOptions: ['Dagdienst', 'Versch. dagdienst', 'Nachtdienst', '2 ploegen', '3 ploegen', '4 ploegen', '5 ploegen', 'Vakantiekracht'],
      vacancy: {
        name: '',
        customer: '',
        amount: '',
        description: '',
        sector: '',
        salaryFrom: '',
        salaryTo: '',
        workHours: '',
        introduction: '',
        descExpect: '',
        descOffer: '',
        shifts: [],
        experiences: [],
        driverLicense: [],
        picture: {
          name: 'vacancyImage',
          file: null
        },
        otherNotes: '',
        apiActive: 0
      },
      tempImage: null
    };
  },
  methods: {
    setDepartmentAndLocation() {
      if (this.vacancy.customer) {
        const departments = this.getDepartments;
        const forcedDepartments = departments.length === 1 ? departments : _.filter(departments, {'forced': true});
        this.vacancy.departments = _.map(forcedDepartments, 'value');
        this.vacancy.location = this.vacancy.customer.location;
      }
    },
    handleFileChange() {
      this.$store.commit('setLoading', true)
      this.vacancy.picture.file = this.$refs.pictureInput.file
      let file = this.vacancy.picture.file
      let ImgCheck = this.$refs.pictureInput

      ImgCheck.getEXIFOrientation(file, (orientation) => {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              var base64 = reader.result;
              this.resetOrientation(base64, orientation, (resetBase64Image) => {
                let newFile = this.dataURItoBlob(resetBase64Image);
                this.vacancy.picture.file = newFile
                this.$store.commit('setLoading', false)
              });
            }
          }
      )
    },
    addVacancy() {
      this.$validator.validate().then(result => {
        if (result) {
          this.disableNavigation = false;
          let vacancy = this.vacancy
          let vacancyData = {
            createdBy: this.$store.getters.getUserData,
            department: this.$store.getters.getUserData.selectedDepartment,
            name: vacancy.name,
            customerId: vacancy.customer.id,
            salaryFrom: vacancy.salaryFrom,
            salaryTo: vacancy.salaryTo,
            description: vacancy.description,
            descExpect: vacancy.descExpect,
            descOffer: vacancy.descOffer,
            shifts: vacancy.shifts,
            workHours:vacancy.workHours,
            sector:vacancy.sector,
            introduction:vacancy.introduction,
            experiences: vacancy.experiences,
            driverLicense: vacancy.driverLicense,
            otherNotes: vacancy.otherNotes,
            geoLocation: {lat: null, lng: null},
            departments: vacancy.departments,
            location: vacancy.location,
          };
          
          this.$store.dispatch('vacancies/set', vacancyData).then((docRef) => {
            if (this.vacancy.picture.file) {
              this.vacancy.picture.path = '/vacancies/' + docRef + '/';
              this.$FB_UPLOADER.upload(this.vacancy.picture).then().catch(() => {
                this.$toasted.global.failedRequest();
              }).catch(() => {
                this.$toasted.global.failedRequest();
              });
              
            }

            this.$router.push('/vacancies');

            this.$toasted.global.successRequest({
              message: 'Vacature aangemaakt'
            });

            this.vacancy = {};
          }).catch(() => {
            this.$toasted.global.failedRequest();
          });

        } else {
          this.$toasted.global.failedFormRequest();
        }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.disableNavigation) {
      this.swalUnsavedChanges().then(result => {
        if (result.value) {
          next();
          this.vacancy = this.vacancyCopy;
        }
      });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters('customers', ['getCustomer', 'getCustomers']),
    ...mapGetters('experiences', ['getExperiences']),
    getDepartments() {
      const departments = this.getCustomer(this.vacancy.customer.id).departments;
      if (!departments || !departments.length) {
        return [{key: '', value: this.getCustomer(this.vacancy.customer.id).location, forced: true}];
      } else {
        return departments;
      }
    }
  },
  watch: {
    vacancy: {
      handler: function (val) {
        if (JSON.stringify(val) !== JSON.stringify(this.vacancyCopy)) {
          this.disableNavigation = true;
        }
      },
      deep: true
    }
  }
}
</script>

